import { DropdownBaseDataControl } from './DropdownBaseDataControl';

export class DropdownListDataControl extends DropdownBaseDataControl {

    componentDidUpdate() {
        var newList = this.props.list ? this.props.list : [];
        if (JSON.stringify(this.state.items) !== JSON.stringify(newList)) {
            this.dataSourceItems = newList;
            this.setState({
                items: newList,
            }, () => {
                var newValue = newList.some(x => x.id === this.state.value) ? this.state.value :
                    newList.length === 1 ? newList[0].id : -1;
                this.setValue(newValue);
            });
        }
    }
}